
$(document).ready(function() {
  window.App = {
    init: function() {
      this.page = this.getPage();
      Forms();
      Category();
      window.App.blurBg = [];
      window.App.headerNav = new Navigation({
        toggle: 'nav-button',
        nav: 'nav-container',
        subnav: 'nav-section',
        openText: 'Open Navigation Menu',
        closedText: 'Close Navigation Menu',
      }).init();


      Tracking.init();
      Load.init();
      window.App.myLocation = new MyLocation();

      window.App.externalPopup = new ExternalPopup();
      window.App.externalPopup.init();

      switch (this.page) {
        case 'home':
          if ($('[data-slide-component]').length) {
            $('.homepage-slider').on('init', function(event, slick, direction) {
              window.App.pageVideos = new Video({
                videoContainer: '.masthead-home__video',
              });
            });
            var sliderComponent = slides('[data-slide-component]');
          }
          break;
        case 'locations':
          window.App.locations = new Locations({
            app_id: window.HERE_MAPS_APP_ID,
            app_code: window.HERE_MAPS_APP_CODE,
          });

          var $alert = $('.js-location-alert');
          var $alertCloseBtn = $('.js-location-alert__close');
          var $alertOpenBtn = $('.js-location-alert__open');
          var $alertMoreBtn = $('.js-location-alert__more');
          var activeClass = 'is-active';
          $alertMoreBtn.on('click', function(e) {
            e.preventDefault();
            var target = $(this).data('target');
            $('[data-tab=' + target + ']').toggleClass(activeClass);
          });
          $alertCloseBtn.on('click', function(e) {
            e.preventDefault();
            $alert.removeClass(activeClass);
            $alertOpenBtn.addClass(activeClass);
            $alertOpenBtn.focus();
          });
          $alertOpenBtn.on('click', function(e) {
            e.preventDefault();
            $alert.addClass(activeClass);
            $alert.focus();
            $alertOpenBtn.removeClass(activeClass);
          });
          break;
        case 'news':
        case 'franchising-news-events':
          window.App.grids = [...document.querySelectorAll('.news-tile-list')];

          if(window.App.grids.length && getComputedStyle(window.App.grids[0]).gridTemplateRows !== 'masonry') {
            window.App.grids = window.App.grids.map(grid => ({
              _el: grid, 
              gap: parseFloat(getComputedStyle(grid).gridRowGap), 
              items: [...grid.childNodes].filter(c => c.nodeType === 1), 
              ncol: 0
            }));
          
            window.App.grids.layout = function() {
              window.App.grids.forEach(grid => {
                grid.ncol = 0
                /* get the post relayout number of columns */
                let ncol = getComputedStyle(grid._el).gridTemplateColumns.split(' ').length;
          
                /* if the number of columns has changed */
                if(grid.ncol !== ncol) {
                  /* update number of columns */
                  grid.ncol = ncol;
          
                  /* revert to initial positioning, no margin */
                  grid.items.forEach(c => c.style.removeProperty('margin-top'));
          
                  /* if we have more than one column */
                  if(grid.ncol > 1) {
                    grid.items.slice(ncol).forEach((c, i) => {
                      let prev_fin = grid.items[i].getBoundingClientRect().bottom /* bottom edge of item above */, 
                          curr_ini = c.getBoundingClientRect().top /* top edge of current item */;
                      
                      c.style.marginTop = `${prev_fin + grid.gap - curr_ini}px`
                    })
                  }
                }
              })
            }
          
            addEventListener('load', e => {
              window.App.grids.layout(); /* initial load */
              addEventListener('resize', window.App.grids.layout) /* on resize */
            }, false);
          }
          document.querySelector('.news-tile-list').addEventListener('change', window.App.grids.layout())
          var checkboxes = $('.article-filters input[type="checkbox"]');
          var checkboxeschecked = $(
            '.article-filters input[type="checkbox"]:checked'
          );
          var countnum = $('.category__toggle-count');
          var catbutton = $('a.category__toggle');
          var catlist = $('.category--article-list');
          var loadbtn = $('.load-more a.load-more__button');
          var checked = [];
          var unchecked = [];

          //A function to update the checkboxes array
          var updateCheckboxes = function(elements) {
            // Zero the arrays out so we're not making them huge
            checked = [];
            unchecked = [];

            //Push the value of checked boxes to the`checkboxes` arr
            $(elements).each(function(index, element) {
              if ($(element).prop('checked') == true) {
                checked.push(
                  $(element)
                    .prop('checked', true)
                    .val()
                );
              } else {
                unchecked.push(
                  $(element)
                    .prop('checked', false)
                    .val()
                );
              }
            });
          };

          if (checkboxeschecked.length) {
            updateCheckboxes(checkboxes);
            catbutton.addClass('category__toggle--open');
            catlist.addClass('category--open');
            countnum.text(checkboxeschecked.length);
            var loadhref = loadbtn.attr('href');
            loadbtn.attr('href', loadhref + '&cat=' + checked.join());
          }

          checkboxes.on('change', function() {
            updateCheckboxes(checkboxes);
            window.location = '?cat=' + checked.join();
          });

          break;
        case 'press':
          var checkboxes = $('.article-filters input[type="checkbox"]');
          var checkboxeschecked = $(
            '.article-filters input[type="checkbox"]:checked'
          );
          var countnum = $('.category__toggle-count');
          var catbutton = $('a.category__toggle');
          var catlist = $('.category--article-list');
          var loadbtn = $('.load-more a.load-more__button');
          var checked = [];
          var unchecked = [];

          //A function to update the checkboxes array
          var updateCheckboxes = function(elements) {
            // Zero the arrays out so we're not making them huge
            checked = [];
            unchecked = [];

            //Push the value of checked boxes to the`checkboxes` arr
            $(elements).each(function(index, element) {
              if ($(element).prop('checked') == true) {
                checked.push(
                  $(element)
                    .prop('checked', true)
                    .val()
                );
              } else {
                unchecked.push(
                  $(element)
                    .prop('checked', false)
                    .val()
                );
              }
            });
          };

          if (checkboxeschecked.length) {
            updateCheckboxes(checkboxes);
            catbutton.addClass('category__toggle--open');
            catlist.addClass('category--open');
            countnum.text(checkboxeschecked.length);
            var loadhref = loadbtn.attr('href');
            loadbtn.attr('href', loadhref + '&cat=' + checked.join());
          }

          checkboxes.on('change', function() {
            updateCheckboxes(checkboxes);
            window.location = '?cat=' + checked.join();
          });

          break;

        case 'faqs':
          window.App.faqs = new Tabs({
            toggle: 'faq-category__button',
            tab: 'faq-list',
          });
          break;
        case 'give':
          giveDisclaimerModal.init();
          break;
        case 'pageant':
          var tileimg = $('.hof-tile__image');
          var content = $('.hof-tile__content');
          var closebtn = $('.hof-tile__close-btn');
          tileimg.on('click', function(e) {
            e.preventDefault();
            var tilecontent = $(this).siblings(content);
            tileimg.add(tilecontent).removeClass('active');
            content.hide();
            $(this).addClass('active');
            tilecontent.fadeIn();
          });
          closebtn.on('click', function(e) {
            e.preventDefault();
            var closebtncontent = $(this).closest('.hof-tile__content');
            tileimg.removeClass('active');
            closebtncontent.hide();
          });
          break;
        case 'calendar-tour':
          window.App.locations = new TourLocations();
          window.App.locations.init();
          break;
        
        case 'hooteroo':
          // Initialize Hooteroo Slider
        $('.hooteroo-ugc-slider').slick({
          initialSlide: 0,
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          centerMode: false,
          centerPadding: '0',
          arrows: false,
          responsive: [
              {
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: true,
                centerMode: true,
                centerPadding: '25%',
                slidesToShow: 1,
                infinite: true,
                centerMode: true
              }
              },
              {
                breakpoint: 480,
                settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '0px',
                slidesToShow: 1,
                infinite: true,
                dots: true,
              }
              }
          ]
        });

        $('.hooteroo-ugc-slider').slick("slickGoTo",1,true);
        $('.hooteroo-ugc-slider').slick("slickGoTo",0,true);  
        break;
      }

      // document.querySelector('.grid-wrapper--slider-2').slick({
      //   infinite: true,
      //   slidesToShow: 1,
      //   slidesToScroll: 1
      // })
      if ($('.js-countdown').length > 0) {
        window.App.countdowns = [];
        $('.js-countdown').each(function(index, element) {
          window.App.countdowns[index] = new Countdown(element);
        });
      }

      if ($('iframe').length > 0) {
        window.App.iframes = [];
        $('iframe.js-iframe-resize').each(function(index, element) {
          $(element).iFrameResize();
          window.App.iframes[index] = element;
        });
        $('iframe.js-iframe-params').each(function(index, element) {
          if (window.location.toString().indexOf('?') > 0) {
            element.src = element.src + window.location.search;
          }
        });
      }

      if ($('.slider').length > 1) {
        $('.slider').slick({
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          prevArrow: '.slider__button--prev',
          nextArrow: '.slider__button--next',
          slide: '.slide',
          pauseOnHover: false,
          dots: $('.slick-slide') > 1,
          dotsClass: 'slider__dots',
        });
      }      

        $('.grid-wrapper--slider-2.slider').slick({
          initialSlide:0,
          slidesToScroll: 1,
          autoplay: false,
          prevArrow: '.slider__button--prev',
          nextArrow: '.slider__button--next',
          slide: '.slide',
          pauseOnHover: false,
          dots: true,
          dotsClass: 'slider-controls',
        });

        if (window.innerWidth < 760) {
          $('.events-slider').slick({
            slidesToScroll: 1,
            slidesToshow: 1,
            autoplay: false,
            prevArrow: '.slider__button--prev',
            nextArrow: '.slider__button--next',
            slide: '.event-slide',
            pauseOnHover: false,
            dots: true,
            dotsClass: 'slider-controls',
  
          });
        }

        if (window.innerWidth < 760) {
          $('.where-are-they-slider').slick({
            slidesToScroll: 1,
            slidesToshow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: '.slider__button--prev',
            nextArrow: '.slider__button--next',
            slide: '.event-slide',
            pauseOnHover: false,
            dots: true,
            dotsClass: 'slider-controls',
  
          });
        }
        if ($('.video-fullwidth').length > 0) {
          window.App.videos = [];
          $('.video-fullwidth').each(function(index, element) {
            window.App.videos[index] = new VideoPlayer(element);
          });
        }
  


        $('.grid-wrapper--slider-2.slider').slick({
          initialSlide:3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          prevArrow: '.slider__button--prev',
          nextArrow: '.slider__button--next',
          slide: '.slide',
          pauseOnHover: false,
          dots: true,
          dotsClass: 'slider-controls',
        });

        if (window.innerWidth < 760) {
          $('.events-slider').slick({
            slidesToScroll: 1,
            slidesToshow: 1,
            autoplay: false,
            prevArrow: '.slider__button--prev',
            nextArrow: '.slider__button--next',
            slide: '.event-slide',
            pauseOnHover: false,
            dots: true,
            dotsClass: 'slider-controls',
  
          });
        }

        if (window.innerWidth < 760) {
          $('.where-are-they-slider').slick({
            slidesToScroll: 1,
            slidesToshow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: '.slider__button--prev',
            nextArrow: '.slider__button--next',
            slide: '.event-slide',
            pauseOnHover: false,
            dots: true,
            dotsClass: 'slider-controls',
  
          });
        }
        if ($('.video-fullwidth').length > 0) {
          window.App.videos = [];
          $('.video-fullwidth').each(function(index, element) {
            window.App.videos[index] = new VideoPlayer(element);
          });
        }
  
      if ($('.masthead--video').length > 0) {
        window.App.mastheadVideo = new VideoPlayer(
          $('.masthead--video').first(),
          {
            content: '.masthead__content',
            video: '.masthead-video__video-embed',
            toggle: '.masthead-video__play-button',
            playPause: '.masthead-video__play-pause-button',
            close: '.masthead-video__video-close',
            placeholder: '.masthead-video__video-placeholder',
          }
        );
      }

      if ($('.blur-bg__canvas').length > 0 && $('.blur-bg__image').length > 0) {
        $('.blur-bg__canvas').each(function(index, element) {
          window.App.blurBg[index] = new BlurBackground({
            canvas: $(this),
            source: $(this)
              .find('.blur-bg__image')
              .first(),
            blur: 50,
          });
          $(window).on('resize', function(e) {
            window.App.blurBg[index].resize();
          });
        });
      }
    },

    getPage: function() {
      var body = $('body');
      var page = null;
      if (body.attr('data-page')) {
        page = body.attr('data-page');
      }

      return page;
    },

    utility: {
      debounce: function(func, wait, immediate) {
        var timeout;
        return function() {
          var context = this,
            args = arguments;
          var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      },
    },
  };

  window.App.init();
});
